import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ClinicPublicPageBecomeClinicPopup } from 'src/clinic/components/ClinicPromotionPage/ClinicPromotionPublicPage'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import { UnsecureSetupContext } from 'src/consumer/context/UnsecureSetupContext'
import { genericHandleChange } from 'src/consumer/helpers/utilFunctions'
import { postDataWithoutParams } from 'src/consumer/services/featureServices'
import { clearStoredServerAvailablePortals } from 'src/shared/config/portalAvailabilityRules'

export default function ClinicOnboardingComponent({ open, onClose }) {
  const [formState, setFormState] = useState({})
  const navigate = useNavigate()
  function handleChange(e) {
    genericHandleChange(e, setFormState)
  }
  const { profileData, refreshProfileData } = useContext(ProfileContext)
  const { unSecureSetupData } = useContext(UnsecureSetupContext)

  async function handleSubmit(event) {
    const form = event.currentTarget
    if (form.checkValidity() === false) {
      event.preventDefault()
      event.stopPropagation()
    } else {
      event.preventDefault()
      const { terms, ...toSubmit } = formState
      const response = await postDataWithoutParams('/api/secure/cp/new', toSubmit)
      if (response.status === 200) {
        const role = localStorage.getItem('authorities')
        const role_array = JSON.parse(role)
        localStorage.setItem('onboardingClinicUser', true)
        localStorage.setItem('authorities', JSON.stringify([...role_array, 'ROLE_CLINIC_PROSPECT']))
        // the stored server portal list predates the new role — drop it so
        // portal access falls back to the just-updated role list until the
        // next profile fetch refreshes it
        clearStoredServerAvailablePortals()
        // sessionStorage.setItem('brandTitle', toSubmit.firstName)
        // sessionStorage.setItem("brand")

        // above line is needed as in clinic layout normal profile is not yet called
        navigate('/clinic-home/new-brand-onboarding')
      }
    }
  }
  console.log({ profileData })

  useEffect(() => {
    const locationCountryCode = localStorage.getItem('countryCode') || 'in'
    const foundCountry = unSecureSetupData?.metaCountries.find(
      (country) => country.id === locationCountryCode.toLowerCase(),
    )
    setFormState((prev) => {
      console.log(prev)
      return {
        ...prev,
        email: prev?.email || profileData?.email || '',
        firstName: prev?.firstName || profileData?.firstName || '',
        waId: profileData?.mobile || '',
        location: {
          country:
            prev?.location?.country ||
            profileData?.location?.country ||
            foundCountry?.title ||
            foundCountry?.name ||
            '',
          countryCode:
            prev?.location?.countryCode ||
            profileData?.location?.countryCode ||
            foundCountry?.id ||
            '',
        },
      }
    })
  }, [profileData, unSecureSetupData?.metaCountries])

  // useEffect(()=>{
  //   console.log({formState})
  // }, [formState])

  return (
    <ClinicPublicPageBecomeClinicPopup
      open={open}
      onClose={onClose}
      handleChange={handleChange}
      setFormState={setFormState}
      formState={formState}
      getProfileData={refreshProfileData}
      profileData={profileData}
      onSubmit={handleSubmit}
    />
  )
}
